/* eslint-disable indent */
/* eslint-disable camelcase */
import store from '../../store'
import { setAutoScores, setAutoInputs } from '../slices/criteriaSelection/auto'

import { LOS, VC } from '../constants/auto'
import { NA } from '../constants/scores'

export function calculateAutoScore() {
  const { auto, modalTiers } = store.getState()
  const { Auto: ATier } = modalTiers
  const { vc } = auto

  // If Auto Tier is 0 or NA , do not calculate score
  // Every score is NA
  if (ATier === 0) {
    store.dispatch(
      setAutoScores({
        field: VC,
        value: NA
      })
    )

    return
  }
  if (vc !== '') {
    if (vc >= 0.0 && vc <= 0.5) {
      store.dispatch(setAutoScores({ field: VC, value: '1' }))
      store.dispatch(setAutoInputs({ field: LOS, value: 'A' }))
    } else if (vc >= 0.51 && vc <= 0.7) {
      store.dispatch(setAutoScores({ field: VC, value: '1' }))
      store.dispatch(setAutoInputs({ field: LOS, value: 'B' }))
    } else if (vc >= 0.71 && vc <= 0.8) {
      store.dispatch(setAutoScores({ field: VC, value: '1' }))
      store.dispatch(setAutoInputs({ field: LOS, value: 'C' }))
    } else if (vc >= 0.81 && vc <= 0.9) {
      store.dispatch(setAutoScores({ field: VC, value: '2' }))
      store.dispatch(setAutoInputs({ field: LOS, value: 'D' }))
    } else if (vc >= 0.91 && vc <= 0.99) {
      store.dispatch(setAutoScores({ field: VC, value: '3' }))
      store.dispatch(setAutoInputs({ field: LOS, value: 'E' }))
    } else {
      store.dispatch(setAutoScores({ field: VC, value: '4' }))
      store.dispatch(setAutoInputs({ field: LOS, value: 'F' }))
    }
  }
}
